/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { get } from "lodash";

export function QuickUserToggler() {
  const { user } = useSelector(state => state.identity, shallowEqual);
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(
    () => {
      return {
        offcanvas:
          objectPath.get(uiService.config, "extras.user.layout") === "offcanvas"
      };
    },
    [uiService]
  );

  return (
    <>
      {layoutProps.offcanvas && (
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="quick-user-tooltip">Thông tin người dùng</Tooltip>
          }
        >
          <div className="topbar-item">
            <div
              className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
              id="kt_quick_user_toggle"
            >
              <>
                <span className="font-weight-bold font-size-base d-md-inline mr-1">
                  Hi,
                </span>
                <span className="text-primary font-weight-bolder font-size-base d-md-inline mr-3">
                  {get(user, "fullname")}
                </span>
                <span className="symbol symbol-35 bg-primary">
                  <span className="symbol-label font-size-h5 font-weight-bold bg-primary text-white">
                    {get(user, "fullname.0")}
                  </span>
                </span>
              </>
            </div>
          </div>
        </OverlayTrigger>
      )}
    </>
  );
}
